import { Injectable } from '@angular/core';
// import sha256 from 'crypto-js/sha256';
// import hmacSHA512 from 'crypto-js/hmac-sha512';
// import Base64 from 'crypto-js/enc-base64';

import * as CryptoJS from 'crypto-js';


@Injectable({
  providedIn: 'root'
})
export class EncryptionService {

  tokenFromUI: string = "alway5H@rdenS3cu";
  encrypted: any = "";
  decrypted: any = "";

  constructor() { }

  encryptUsingAES256(request:String) {
    let _key = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
    let _iv = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
    let encrypted = CryptoJS.AES.encrypt(
      request, _key, {
        keySize: 16,
        iv: _iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
   return this.encrypted = encrypted.toString();
  }

  encryptUsingAES256SAV(request:String,key:String) {
    let _key = CryptoJS.enc.Utf8.parse(key);
    let _iv = CryptoJS.enc.Utf8.parse(key);
    let encrypted = CryptoJS.AES.encrypt(
      request, _key, {
        keySize: 16,
        iv: _iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
   return this.encrypted = encrypted.toString();
  }

  decryptUsingAES256(request:String,key:String) {

    let _key = CryptoJS.enc.Utf8.parse(key);
    let _iv = CryptoJS.enc.Utf8.parse(key);


    let decrypted = CryptoJS.AES.decrypt(
      request, _key, {
        keySize: 16,
        iv: _iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });

      return this.decrypted = decrypted.toString(CryptoJS.enc.Utf8);
  }



}

